import { computed, inject, isSignal, Signal } from '@angular/core';
import { TranslationService } from '../translation.service';

export const translate = (key: string | Signal<string>) => {
  const store = inject(TranslationService);
  return computed(() => {
    return store.translate(isSignal(key) ? key() : key)();
  });
};
